
import { useState } from 'react';
import HeroSection from './components/HeroSection';
import TargetAudienceSection from './components/TargetAudienceSection';
import ProgramSection from './components/ProgramSection';
import BenefitsSection from './components/BenefitsSection';
import CourseInfoSection from './components/CourseInfoSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import StickyHeader from './components/StickyHeader';

const HomePage = () => {
  const [showStickyHeader, setShowStickyHeader] = useState(false);

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    setShowStickyHeader(scrollPosition > 100);
  };

  useState(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <StickyHeader show={showStickyHeader} onScrollToSection={scrollToSection} />
      <HeroSection onScrollToSection={scrollToSection} />
      <TargetAudienceSection />
      <ProgramSection />
      <BenefitsSection />
      <CourseInfoSection />
      <TestimonialsSection />
      <FAQSection />
      <Footer />
    </div>
  );
};

export default HomePage;
